import * as i0 from '@angular/core';
import { inject, APP_ID, Service } from '@angular/core';
const counters = /*#__PURE__*/new Map();
class _IdGenerator {
  _appId = /*#__PURE__*/inject(APP_ID);
  static _infix = `a${ /*#__PURE__*/ /*#__PURE__*/Math.floor(/*#__PURE__*/Math.random() * 100000).toString()}`;
  getId(prefix, randomize = false) {
    if (this._appId !== 'ng') {
      prefix += this._appId;
    }
    let count = counters.get(prefix);
    if (count === undefined) {
      count = 0;
    } else {
      count++;
    }
    counters.set(prefix, count);
    return `${prefix}${randomize ? _IdGenerator._infix + '-' : ''}${count}`;
  }
  static ɵfac = function _IdGenerator_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || _IdGenerator)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineService({
    token: _IdGenerator,
    factory: _IdGenerator.ɵfac
  });
}
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { _IdGenerator };
